var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contract-create-component',{attrs:{"routeNameToContractsList":_vm.route_name,"advisor":'CA'}})}
var staticRenderFns = []

export { render, staticRenderFns }